// Scrollbar auto-hide: em elementos com a classe `scroll-auto-hide`, o thumb
// fica transparente em repouso e aparece só enquanto rola (classe `is-scrolling`,
// removida ~900ms após a última rolagem). Um listener global em captura cobre
// qualquer container marcado — sem hook por componente.
const IDLE_MS = 900;
const timers = new WeakMap<Element, number>();

function onScroll(e: Event): void {
  const el = e.target;
  if (!(el instanceof HTMLElement) || !el.classList.contains('scroll-auto-hide')) return;
  el.classList.add('is-scrolling');
  const prev = timers.get(el);
  if (prev) window.clearTimeout(prev);
  timers.set(
    el,
    window.setTimeout(() => el.classList.remove('is-scrolling'), IDLE_MS),
  );
}

/** Instala o listener global (idempotente). Retorna a função de limpeza. */
export function installAutoHideScrollbars(): () => void {
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  return () => document.removeEventListener('scroll', onScroll, { capture: true } as EventListenerOptions);
}
